export default __webpack_public_path__ + "static/media/wp-fact-sheet.dd8b1510.pdf";